import React from 'react';

import { styled } from '@compiled/react';
import StatusField from '@atlassian/jira-issue-view-foundation/src/status';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<>
		<FoundationContextWrapper
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			data-testid="issue.views.issue-base.context.status-and-approvals-wrapper.status-and-approval"
		>
			<StatusField key="STATUS" />
		</FoundationContextWrapper>
	</>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FoundationContextWrapper = styled.div({
	marginBottom: 0,
});
FoundationContextWrapper.displayName = 'FoundationContextWrapper';
